import Integer from "./Integer"

const UNITS = [`ms`, `s`, `m`, `h`, `d`, `w`, `mo`, `y`, `с`]

export default class DateTime extends Integer {
  constructor(unit = `ms`) {
    super()

    this.format = `date-time`

    if (!UNITS.includes(unit)) {
      throw new Error(
        `Invalid DateTime unit ${unit}. Expects one of ${UNITS.join(`, `)}`,
      )
    }
    this.unit = unit
    this.description = `Unix like date format`
  }
}
